<template>
  <div class="home">
    /
  </div>
</template>

<script>
export default {
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem('jwt');
    },
  },
};
</script>
